import React, { useState } from 'react';
import homeNoText from '../assets/homeNoText.jpg';
import navimg from '../assets/navimg.png';
import { FaFacebookF,FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { GiHamburgerMenu } from 'react-icons/gi';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from 'react-scroll';

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 h-full"
        style={{ 
          backgroundImage: `url(${homeNoText})`,
          backgroundSize: 'cover', 
          backgroundPosition: 'top center', 
          backgroundRepeat: 'no-repeat',
          zIndex: 1, 
        }}
      ></div>

      {/* Navbar */}
      <nav className="absolute top-3 left-0 right-0 h-[67px] bg-white z-20 shadow-md flex justify-between items-center px-4 mx-auto w-full">
        {/* Left side of the navbar */}
        <div className="flex items-center gap-2">
          <img src={navimg} alt="Logo for the family reservation initiative" className="w-[60px] h-[35px] sm:w-[80px] sm:h-[45px] md:w-[100px] md:h-[58px]" />
          <h1 className="font-UnifrakturCook font-bold text-[#B50301]"
    style={{
        fontSize: "clamp(1rem, 2vw + 1rem, 2rem)", // Responsive font size
        lineHeight: "clamp(1.2rem, 2.5vw + 1.2rem, 3.5rem)", // Responsive line height
        maxWidth: "clamp(60%, 80%, 100%)", // Shrinks width as screen size decreases
        whiteSpace: "nowrap", // Ensures single-line text
        overflow: "hidden", // Prevents overflow outside the navbar
        textOverflow: "ellipsis", // Adds ellipsis if text still overflows
    }}
>
    एक परिवार, एक आरक्षण
</h1>
        </div>

        {/* Toggle Button for Medium and Small Screens Only */}
        <button
          className="lg:hidden text-2xl sm:text-3xl text-[#B50301] focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <GiHamburgerMenu />
        </button>

        {/* Navbar Links (Dropdown for Medium and Smaller Screens, Inline for Larger Screens) */}
        {/* Navbar Links (Dropdown for Medium and Smaller Screens, Inline for Larger Screens) */}
<div className={`lg:flex lg:items-center ${isOpen ? 'block' : 'hidden'} absolute lg:relative top-[67px] lg:top-auto left-0 w-full lg:w-auto bg-white lg:bg-transparent shadow-md lg:shadow-none z-30`}>
  <div className="flex flex-row lg:flex-row items-center gap-2 lg:gap-4 py-4 lg:py-0 px-4 lg:px-0">
    <Link to="home" smooth={true} duration={700} className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold">Home</Link>
    <RouterLink to="/whatWeDo" className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold">अभियान के बारे में</RouterLink>
    <Link to="motive" smooth={true} duration={700} className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold">अभियान के सूत्रधार</Link>
    <RouterLink to="/questions" className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold">सामान्यतः पूछे जाने वाले प्रश्न</RouterLink>
    <RouterLink to="/humsejude" className="text-[#B50301] cursor-pointer hover:scale-105 duration-200 hover:text-orange-700 text-xs sm:text-sm md:text-base font-extrabold">हमसे जुडें</RouterLink>

    {/* Button to navigate to Video Upload */}
    <Link to="video-upload" smooth={true} duration={700}>
      <button className="bg-[#B50301] text-white px-2 sm:px-3 md:px-4 py-1 sm:py-2 rounded hover:scale-105 duration-200 text-xs sm:text-sm md:text-base font-extrabold">
        आपका योगदान
      </button>
    </Link>
  </div>
</div>

      </nav>

      {/* Section with Text and Play Video Link */}
      <div className="absolute flex justify-end items-center z-20 w-full sm:w-[90%] md:w-[80%] lg:w-[70%] bottom-[17%] px-4 lg:ml-60">
        {/* Play Video Box */}
        <div className="w-[322px] h-[51px] flex items-center justify-center text-lg font-semibold cursor-pointer">
          <div className='w-[161px] h-[51px] bg-red-500 flex items-center justify-center text-white font-semibold text-lg'>
          <p>हमारा अभियान</p>
          </div>
          <a href="https://www.youtube.com/@1family1reservation" target="_blank" rel="noopener noreferrer" className="flex items-center text-black hover:text-red-500">
            <span className="mr-2">Play Video</span>
            <button className="text-2xl">▶</button>
          </a>
        </div>
      </div>

 {/* Middle Text Section */}
<div className="absolute z-20 w-full text-center" style={{ top: '45%', transform: 'translateY(-50%)' }}>
  <h1 className="text-gray-800 font-extrabold leading-tight"
    style={{
      fontSize: "clamp(1.5rem, 4vw + 1rem, 7rem)"  // Responsive font size for scaling
    }}
  >
    क्या आरक्षण प्राप्त
  </h1>
  <h1 className="text-blue-950 font-bold leading-tight lg:ml-64"
    style={{
      fontSize: "clamp(1.5rem, 4vw + 1rem, 7rem)"  // Same here for consistency
    }}
  >
    अफसरों और नेताओं के बच्चों
  </h1>
  <h1 className="text-gray-900 font-bold leading-tight lg:ml-40"
    style={{
      fontSize: "clamp(1.5rem, 4vw + 1rem, 7rem)"  // Responsive scaling
    }}
  >
    को <span className="text-[#B50301] lg:text-9xl">आरक्षण</span> मिलना
  </h1>
  <h1 className="text-gray-900 font-bold leading-tight"
    style={{
      fontSize: "clamp(1.5rem, 4vw + 1rem, 7rem)"  // Responsive scaling
    }}
  >
    चाहिए?
  </h1>
</div>





      {/* Follow Us Section */}
      <div 
        className="absolute bg-red-500 z-20 w-[90%] sm:w-[70%] md:w-[345px] h-[45px] sm:h-[51px] flex justify-between items-center px-4"
        style={{
          bottom: '3%',
          right: '2%',
          maxWidth: 'calc(100% - 16px)',
          marginBottom: '1%', // Adjusted for smaller screens
          transition: 'margin-bottom 0.3s ease-in-out'
        }}
      >
        <p className="text-white font-semibold text-sm sm:text-lg md:text-2xl">Follow Us:</p>

        <div className="flex items-center gap-3 sm:gap-5 md:gap-7">
          <a href="https://www.facebook.com/1reservation/" target="_blank" rel="noopener noreferrer" className="text-white text-xl sm:text-2xl md:text-4xl hover:text-gray-200">
            <FaFacebookF />
          </a>
          <a href="https://x.com/1fam1reserv" target="_blank" rel="noopener noreferrer" className="text-white text-xl sm:text-2xl md:text-4xl hover:text-gray-200">
            <FaXTwitter />
          </a>
          <a href="https://www.youtube.com/@1family1reservation" target="_blank" rel="noopener noreferrer" className="text-white text-xl sm:text-2xl md:text-4xl hover:text-gray-200">
            <FaYoutube />
          </a>
        </div>
      </div>

      {/* Additional CSS for mobile responsiveness */}
      <style jsx>{`
        @media (max-width: 640px) {
          #home .absolute.bg-red-500 {
            bottom: 1%; // Adjusts "Follow Us" position for smaller screens
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
